import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { House, ChartBar, Package, User } from 'phosphor-react';

const TABS = [
  { to: '/dashboard', label: 'Início', icon: House },
  { to: '/progress-history', label: 'Progresso', icon: ChartBar },
  { to: '/products', label: 'Produtos', icon: Package },
  { to: '/settings', label: 'Perfil', icon: User },
];

/** Barra de navegação do mock (2026-06-11). Só aparece nas abas raiz. */
export default function BottomNav() {
  const { pathname } = useLocation();
  if (!TABS.some((t) => t.to === pathname)) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white/90 dark:bg-gray-900/95 backdrop-blur-md border-t border-nude-100 dark:border-gray-700 safe-area-bottom">
      <div className="max-w-lg mx-auto flex">
        {TABS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => `
              flex-1 flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors
              ${isActive ? 'text-blush-500' : 'text-nude-400 dark:text-gray-500 hover:text-blush-400'}
            `}
          >
            <Icon className="w-5 h-5" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
